export enum MapOPEEnum {
  GetMapPointers = 'getMapPointers'
}
